import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackEvent } from '../lib/pixel';
const BASE_CHECKOUT = 'https://pay.hotmart.com/X106319337N?bid=1781834430846';
const PREMIUM_CHECKOUT = 'https://pay.hotmart.com/Y106319794C?bid=1781986826672';
function CheckItem({
  text,
  dark
}: {
  text: string;
  dark?: boolean;
}) {
  return <li className="flex items-center gap-2.5" data-id="element-61">
      <span className={`flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[11px] font-bold ${dark ? 'bg-[#C2683D] text-white' : 'bg-[#2E4F48] text-[#F4ECDD]'}`} data-id="element-62">
        ✓
      </span>
      <span className="text-[#1e3a1e] text-sm font-semibold" data-id="element-63">{text}</span>
    </li>;
}
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section id="premium" className="bg-[#ede4d0] py-12 md:py-16 px-4 sm:px-6 border-t border-[#2d3f2a]/5" style={{
    scrollMarginTop: '80px'
  }} data-id="element-64">
      <div className="container mx-auto max-w-4xl" data-id="element-65">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-66">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-2 leading-tight text-[#1e3a1e]" data-id="element-67">
            ELEGÍ TU FORMACIÓN
          </h2>
          <p className="text-[#5a5040] text-sm md:text-base font-medium" data-id="element-68">
            Dos formas de empezar tu formación. Elegí la que mejor se adapte a
            vos.
          </p>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-7 items-stretch max-w-3xl mx-auto ${vis2 ? 'is-visible' : ''}`} data-id="element-69">
          {/* Base Card */}
          <div className="relative rounded-3xl flex flex-col text-center bg-[#faf3e3] border border-[#2d3f2a]/15 shadow-md overflow-hidden mt-3 md:mt-0" data-id="element-70">
            {/* Green header band */}
            <div className="bg-[#2E4F48] pt-7 pb-6 px-5 sm:px-7" data-id="element-71">
              <h3 className="text-lg sm:text-xl font-serif font-bold text-[#F4ECDD] mb-2 leading-tight" data-id="element-72">
                📘 FORMACIÓN INTEGRAL
              </h3>
              <p className="inline-block bg-[#1C3B36] text-[#F4ECDD] font-bold text-xs px-3.5 py-1 rounded-full tracking-wide" data-id="element-73">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="p-5 sm:p-7 flex flex-col flex-grow" data-id="element-74">
              <ul className="space-y-2 mb-5 text-left max-w-xs mx-auto w-full" data-id="element-75">
                <CheckItem text="6 Tomos Profesionales" data-id="element-76" />
                <CheckItem text="6 Bonos Exclusivos" data-id="element-77" />
                <CheckItem text="Certificado Digital" data-id="element-78" />
                <CheckItem text="Acceso Inmediato" data-id="element-79" />
              </ul>

              <div className="flex flex-col items-center justify-center mb-5 pt-4 border-t border-dashed border-[#2d3f2a]/25 mt-auto" data-id="element-80">
                <span className="text-[#9a8c70] line-through text-base font-bold" data-id="element-81">
                  $39 USD
                </span>
                <p className="text-4xl sm:text-5xl font-extrabold text-[#1C3B36] leading-none mt-1" data-id="element-82">
                  $17{' '}
                  <span className="text-xl align-middle text-[#5a5040]" data-id="element-83">
                    USD
                  </span>
                </p>
              </div>

              <a id="oferta-cta" href={BASE_CHECKOUT} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
              content_name: 'Formación Integral',
              value: 17,
              currency: 'USD'
            })} className="w-full block py-3.5 rounded-xl text-white font-bold text-sm tracking-widest uppercase text-center transition-all duration-300 bg-[#2E4F48] hover:bg-[#1C3B36] shadow-md hover:shadow-lg hover:-translate-y-1 scroll-mt-24" style={{
              fontFamily: "'Inter', sans-serif",
              letterSpacing: '0.05em'
            }} data-id="element-84">
                → QUIERO EL INTEGRAL
              </a>

              <p className="text-[#1C3B36] text-[11px] mt-2.5 font-bold" data-id="element-85">
                💱 Pagás en la moneda de tu país
              </p>
            </div>
          </div>

          {/* Premium Card — recommended */}
          <div id="oferta-box" className="relative rounded-3xl flex flex-col text-center bg-[#faf3e3] border-2 border-[#b8860b]/70 shadow-[0_24px_55px_rgba(28,59,54,0.25)] ring-4 ring-[#b8860b]/20 overflow-hidden md:scale-[1.04] z-10 scroll-mt-24" data-id="element-86">
            {/* Floating badge */}
            <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-[#C2683D] text-white text-[11px] font-bold px-5 py-1.5 rounded-full shadow-md z-20 whitespace-nowrap tracking-[0.18em] uppercase animate-pulse" data-id="element-87">
              ⭐ Recomendado
            </div>

            {/* Green header band */}
            <div className="bg-[#1C3B36] pt-14 pb-6 px-5 sm:px-7" data-id="element-88">
              <h3 className="text-lg sm:text-xl font-serif font-bold text-[#F4ECDD] mb-2 leading-tight" data-id="element-89">
                🏆 FORMACIÓN INTEGRAL PREMIUM
              </h3>
              <p className="inline-block bg-[#C2683D] text-white font-bold text-xs px-3.5 py-1 rounded-full tracking-wide" data-id="element-90">
                Todo el Integral + Kit Profesional
              </p>
            </div>

            <div className="p-5 sm:p-7 flex flex-col flex-grow" data-id="element-91">
              <ul className="space-y-2 mb-5 text-left max-w-xs mx-auto w-full" data-id="element-92">
                <CheckItem text="Toda la Formación Integral" dark data-id="element-93" />
                <CheckItem text="Vademécum Interactivo" dark data-id="element-94" />
                <CheckItem text="Kit Consultor Profesional" dark data-id="element-95" />
                <CheckItem text="Cuaderno de Sanación Transgeneracional" dark data-id="element-96" />
              </ul>

              <div className="flex flex-col items-center justify-center mb-5 pt-4 border-t border-dashed border-[#b8860b]/40 mt-auto" data-id="element-97">
                <span className="text-[#9a8c70] line-through text-base font-bold" data-id="element-98">
                  $59 USD
                </span>
                <p className="text-4xl sm:text-5xl font-extrabold text-[#1C3B36] leading-none mt-1" data-id="element-99">
                  $25{' '}
                  <span className="text-xl align-middle text-[#b8860b]" data-id="element-100">
                    USD
                  </span>
                </p>
                <span className="mt-3 inline-block bg-[#C2683D] text-white text-[10px] font-bold rounded-full px-3.5 py-1.5 tracking-wide uppercase shadow-sm" data-id="element-101">
                  🔥 Mejor valor
                </span>
              </div>

              <a id="oferta-cta-premium" href={PREMIUM_CHECKOUT} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
              content_name: 'Formación Integral Premium',
              value: 25,
              currency: 'USD'
            })} className="w-full block py-3.5 rounded-xl text-white font-bold text-sm tracking-widest uppercase text-center transition-all duration-300 bg-[#C2683D] hover:bg-[#A8542F] shadow-[0_12px_28px_rgba(194,104,61,0.4)] hover:shadow-[0_16px_36px_rgba(194,104,61,0.5)] hover:-translate-y-1" style={{
              fontFamily: "'Inter', sans-serif",
              letterSpacing: '0.05em'
            }} data-id="element-102">
                → QUIERO EL PREMIUM
              </a>

              <p className="text-[#1C3B36] text-[11px] mt-2.5 font-bold" data-id="element-103">
                💱 Pagás en la moneda de tu país
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}